// ============================================================================
// SPLAY TREE - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'splay-tree',
  name: 'Splay Tree',
  category: 'Data Structures',
  complexity: {
    time: 'O(log N) amortized per operation',
    space: 'O(N)'
  },
  description: 'A self-adjusting binary search tree that moves accessed elements to the root through splaying operations. Provides good amortized performance and enables efficient access to frequently accessed elements.'
};
